import { isStablecoin } from './stablecoins';

/* ══════════════════════════════════════════════════════════════════════════
   ALTSZEZON-INDEX (Terminál-javítások 1. kör, A.4) — egyetlen számítás
   ─────────────────────────────────────────────────────────────────────────
   A Terminál fül (home/MarketState.jsx) és az RSI-áttekintés (AltseasonIndex.js)
   eddig kétféleképpen számolt (az egyik a stabilcoinokat is altcoinnak vette, a
   másik a BTC-dominanciával ±10 pontot korrigált), ezért egyszerre más-más értéket
   mutattak. Most mindkettő ezt használja, a megszokott definíció szerint:
   a piaci kapitalizáció szerinti top 10 altcoin (BTC, stabilcoinok, csomagolt és
   staking-tokenek nélkül) közül hány százalék ment jobban 7 nap alatt, mint a BTC.
   ══════════════════════════════════════════════════════════════════════════ */

export const ALTSZEZON_N = 10;
export const ALTSZEZON_INFO = 'A piaci kapitalizáció szerinti top 10 altcoin (stabilcoinok és csomagolt tokenek nélkül) közül hány százalék teljesített jobban 7 nap alatt a BTC-nél. 75 felett altszezon, 25 alatt BTC-szezon.';

// csomagolt és staking-tokenek: a BTC-t vagy az ETH-t követik, nem önálló altcoinok
const DERIVATIVE_IDS = new Set([
  'wrapped-bitcoin', 'coinbase-wrapped-btc', 'lombard-staked-btc', 'solv-btc', 'staked-ether', 'wrapped-steth', 'weth',
  'binance-peg-weth', 'wrapped-eeth', 'wrapped-beacon-eth', 'rocket-pool-eth', 'mantle-staked-ether', 'kelp-dao-restaked-eth',
  'jito-staked-sol', 'binance-staked-sol',
]);

/** coins: a CoinGecko markets lista (piaci kapitalizáció szerint rendezve).
 *  → { score (0–100 | null), beating, total, btc7d, alts } */
export function altszezonIndex(coins, n = ALTSZEZON_N) {
  const list = Array.isArray(coins) ? coins : [];
  const btc = list.find(c => c.id === 'bitcoin');
  const btc7d = btc?.price_change_percentage_7d_in_currency;
  if (!list.length || btc7d == null) return { score: null, beating: 0, total: 0, btc7d: btc7d ?? null, alts: [] };
  const alts = list.filter(c => c.id !== 'bitcoin' && !isStablecoin(c) && !DERIVATIVE_IDS.has(c.id)).slice(0, n);
  const beating = alts.filter(c => (c.price_change_percentage_7d_in_currency ?? 0) > btc7d).length;
  return { score: alts.length ? Math.round((beating / alts.length) * 100) : null, beating, total: alts.length, btc7d, alts };
}
